<template>
  <div id="user">
    <van-loading v-if="isLoading" size="24px" vertical style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
      ">加载中...</van-loading>
    <div v-else class="user-page-main">
      <div class="user-main-info">
        <div class="user-phone">
          <span class="user-name">{{ username}}
            <!-- <img class="user-level" :class="{ shorter: userInfo.serverType === '-1' }" v-if="userInfo.serverType"
              :src="iconPaths[userInfo.serverType]" /> -->
          </span>
          <!-- <span class="user-plan" @click="goPartnership">合伙人计划</span> -->
        </div>
        <!-- <div class="user-status">
          <span class="status-tag" :class="{ active: userInfo.realNameAuthStatus }">{{ userInfo.realNameAuthStatus ?
            "已实名" : "未实名" }}</span>
          <span class="status-tag" :class="{ active: `${userInfo.investAgencySignType}` === '1' }">{{
            investAgencySignMap[userInfo.investAgencySignType] }}</span>
        </div> -->
      </div>
      <div class="user-second-info">
        <!-- <div class="info-row" @click="goStrategyAnalytics">
          <div class="row-title">
            <span>资产概览</span>
            <van-icon name="arrow" />
          </div>
          <div class="info-content">
            <div class="content-desc">总资产</div>
            <span class="content-weight">{{
              formatNumber(positionInfo.totalBalance)
            }}</span><span class="content-normal" v-if="formatNumber(positionInfo.totalBalance) !== '0'" :class="{
                positive: positionInfo.todayFloatPL > 0,
                negative: positionInfo.todayFloatPL < 0,
                // zero: positionInfo.todayFloatPL === 0,
              }">{{ formatPL(positionInfo.todayFloatPL) }} ({{
                formatPercent(positionInfo.todayFloatRate)
              }})</span>
          </div>
        </div> -->
        <!-- <div class="info-row" v-if="balanceCenterVo.totalBalance > 0" @click="goSubscription">
          <div class="row-title">
            <span class="content-desc">算力值</span>
            <van-icon name="arrow" />
          </div>
          <div class="info-content">
            <div class="content-left">
              <div class="content-desc">算力值余额</div>
              <div class="content-weight">
                {{ balanceCenterVo.totalBalance }}
              </div>
            </div>
            <div class="content-right">
              <div class="content-desc">服务器剩余时长（天）</div>
              <div class="content-weight">
                {{ balanceCenterVo.totalServerTime }}
              </div>
            </div>
          </div>
        </div> -->
        <!-- 去充值算力 -->
        <!-- <div v-else class="empty-balance">
          <div>暂无算力值</div>
          <div>充值并兑换算力值后可执行交易</div>
          <van-button type="primary" @click="goPayCredit" color="#000"
            style="width: 155px; height: 36px; margin-top: 16px" block round>去充值</van-button>
        </div> -->
        <!-- <div class="info-row row-no-bottom" @click="goCodeEditor">
          <div class="row-title">
            <span>编程交易</span>
            <van-icon name="arrow" />
          </div>
        </div> -->
        <div class="info-row row-no-bottom" @click="qrCodeVisible = true">
          <div class="row-title">
            <span>联系客服</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="info-row row-no-bottom">
          <router-link class="row-title" to="/protocolList">
            <span>隐私协议</span>
            <van-icon name="arrow" />
          </router-link>
        </div>
        <!-- <div class="info-row row-no-bottom" @click="showWelcomeCarousel">
          <div class="row-title">
            <span>使用说明</span>
            <van-icon name="arrow" />
          </div>
        </div> -->
        <div class="info-row row-no-bottom" @click="logoutHandler">
          <div class="row-title">
            <span>退出登录</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>

    <!-- 轮播弹窗组件 -->
    <welcome-carousel :needComplete="needComplete" :visible="welcomeCarouselVisible" @close="handleWelcomeCarouselClose"
      @start="handleWelcomeCarouselStart" />
    <!-- 联系客服 -->
    <Popup v-model="qrCodeVisible" :style="{
      boxSizing: 'border-box',
      width: '270px',
      borderRadius: '8px',
      padding: '20px 16px',
      background: '#ffffff',
    }" :overlay="true" :close-on-click-overlay="true">
      <div class="wx-qrcode-popup">
        <div class="wx-popup-title">联系客服</div>
        <div class="wx-popup-desc">
          添加客服微信可获得1对1系统使用帮助及更多福利
        </div>
        <div class="wx-popup-qrcode">
          <img src="https://homepage-oss.oss-cn-beijing.aliyuncs.com/h5/kefu.jpg" alt="二维码" />
        </div>
        <van-button type="primary" @click="qrCodeVisible = false" color="#000" style="height: 36px; margin-top: 20px"
          block round>扫一扫添加客服</van-button>
      </div>
    </Popup>
  </div>
</template>
<script>
import { Toast, Popup, Loading } from "vant";
import { userInfoDetail, logout } from "@/api/theApi";
import WelcomeCarousel from "@/components/WelcomeCarousel.vue";
export default {
  components: {
    WelcomeCarousel,
    Popup,
    [Loading.name]: Loading,
  },
  data() {
    return {
      // 页面 loading 状态
      isLoading: false,
      username: "",
      userInfo: {},
      balanceCenterVo: {},
      positionInfo: {
        totalBalance: 0, // 个人总资产
        cashBalance: 0,
        positionBalance: 0,
        totalFloatPL: 0,
        todayFloatPL: 0,
        todayFloatRate: 0,
      },
      iconPaths: {
        "-1": require("@/assets/user/free-level.png"),
        1: require("@/assets/user/basic-level.png"),
        2: require("@/assets/user/middle-level.png"),
        3: require("@/assets/user/high-level.png"),
      },
      investAgencySignMap: {
        1: "已签约",
        2: "签约确认中",
        "-1": "未签约",
      },
      showStrategyPicker: false,
      activeTab: 0,
      strategyLoading: false,
      strategyFinished: false,
      allStrategyLoading: false,
      allStrategyFinished: false,
      goodStrategyList: [],
      allStrategyList: [],
      sortValue: 0,
      // sortOptions: [
      //   { text: "年化回报率", value: 0 },
      //   { text: "最大回撤", value: 1 },
      //   { text: "夏普比率", value: 2 },
      // ],
      showHelpQrcode: false,
      cloudServerShow: false,
      codeEditorShow: false,
      pythonCode: "",
      cloudServer: null,
      isTesting: false,
      testPassed: false,
      testStatusText: "",
      testFailed: false,
      // 实名认证相关数据
      identityVerificationShow: false,
      isIdentityVerified: false,
      // 状态弹窗相关数据
      statusPopupVisible: false,
      statusPopupType: "success",
      statusPopupTitle: "",
      statusPopupDescription: "",
      showValidationPopup: false,
      validationTitle: "生成交易代码你需要",
      confirmText: "我知道了",
      validateInfo: {},
      isShowCancelButton: false,
      cancelText: "取消",
      showNotificationPopup: false,
      notificationTitle: "签约投顾服务通知",
      notificationContent:
        "您的签约将在1-2个工作日完成，完成后将短信通知您签约状态。",
      welcomeCarouselVisible: false,
      qrCodeVisible: false,
      needComplete: true,
    };
  },
  computed: {},
  methods: {
    goCodeEditor() {
      this.$router.push({ path: "/cloudServer" });
    },
    goSubscription() {
      try {
        if (this.$router) {
          this.$router.push({ path: "/subscription" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.warn("路由跳转失败:", err);
            }
          });
        }
      } catch (error) {
        console.warn("路由跳转异常:", error);
      }
    },
    goPartnership() {
      try {
        if (this.$router) {
          this.$router.push({ path: "/partnership" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.warn("路由跳转失败:", err);
            }
          });
        }
      } catch (error) {
        console.warn("路由跳转异常:", error);
      }
    },
    goPayCredit() {
      this.$router.push({ path: "/subscription?activeTab=credit" });
    },
    goStrategyAnalytics() {
      try {
        if (this.$router) {
          this.$router.push({ path: "/holdingdetail" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.warn("路由跳转失败:", err);
            }
          });
        }
      } catch (error) {
        console.warn("路由跳转异常:", error);
      }
    },
    async logoutHandler() {
      localStorage.clear();
      logout();
      window.location.href = "/";
    },
    async init() {
      const username = localStorage.getItem("username");
      this.username = username;
      if (username) {
        await this.fetchUserInfo();
      } else {
        Toast.fail("您已退出\n请重新登录");
        setTimeout(() => {
          this.$router.push({
            path: "/login",
          });
        }, 2000);
      }
    },
    // 用户信息
    async fetchUserInfo() {
      this.isLoading = true;
      const res = await userInfoDetail(this.username);
      if (res.code === 20000) {
        this.userInfo = {
          ...res.data.userInfo,
          // 未签约时，设置 investAgencySignType 为 -1
          investAgencySignType: res.data.userInfo.investAgencySignStatus
            ? res.data.userInfo.investAgencySignType
            : "-1",
          serverType: res.data.userInfo.serverType
            ? res.data.userInfo.serverType
            : "-1",
        };
        this.balanceCenterVo = res.data.balanceCenterVo;
        this.positionInfo = res.data.userPositionVo
          ? res.data.userPositionVo.positionInfo
          : {};
        this.isLoading = false;
        if (res.data.userInfo.isFirstVisit) {
          this.welcomeCarouselVisible = true;
        }
      } else {
        Toast.fail("获取用户信息失败");
      }
    },
    showWelcomeCarousel() {
      // 实现轮播弹窗的逻辑
      this.needComplete = false;
      this.welcomeCarouselVisible = true;
    },
    handleWelcomeCarouselClose() {
      this.welcomeCarouselVisible = false;
    },
    handleWelcomeCarouselStart() {
      this.welcomeCarouselVisible = false;
    },
    // 格式化数字，添加千位分隔符
    formatNumber(num) {
      if (num === null || num === undefined || isNaN(num)) return "0";
      return Number(num).toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
    // 格式化百分比
    formatPercent(decimal) {
      if (decimal === null || decimal === undefined || isNaN(decimal) || Number(decimal) === 0)
        return "0";
      const percent = decimal.toFixed(2);
      return `${decimal > 0 ? "+" : ""}${percent}${percent === "0" || percent === "0.00" ? "" : "%"
        }`;
    },
    // 格式化盈亏金额
    formatPL(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return "0";
      const formatted = Number(amount).toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return `${amount > 0 ? "+" : ""}${formatted}`;
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
  },
};
</script>
<style lang="less" scoped>
#user {
  padding-bottom: 112px;
  background: #f5f5f5;
  position: relative;

  .van-loading-overlay {
    background-color: rgba(255, 255, 255, 0.7);
  }

  .user-main-info {
    // padding: 20px 24px 24px;
    padding: 20px 24px 32px 24px;
    background-color: #111;

    .user-phone {
      display: flex;
      justify-content: space-between;

      .user-name {
        display: flex;
        gap: 6px;
        color: #fff;
        font-weight: 600;
        font-size: 24px;

        .user-level {
          width: 67px;
        }

        .user-level.shorter {
          width: 57px;
        }
      }

      .user-plan {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
        font-size: 12px;
        color: #fff;
        padding: 0 8px;
        border-radius: 93.75px;
        border: 1px solid hsla(0, 0%, 100%, 1);
      }
    }

    .user-status {
      padding-top: 12px;

      .status-tag {
        padding: 2px 6px;
        margin-right: 8px;
        border-radius: 2px;
        font-weight: 400;
        font-size: 12px;
        color: #040404;
        background: #e5e5e5;
      }
    }

    .status-tag.active {
      color: #074a15;
      background: #e8f8eb;
    }
  }

  .user-second-info {
    // height: calc(100vh - 220px);
    padding: 20px 16px;
    transform: translateY(-8px);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: #f8f8f8;

    .info-row {
      padding: 12px 16px;
      border-radius: 8px;
      background: #fff;
      margin-bottom: 16px;

      .row-title {
        display: flex;
        justify-content: space-between;
        padding-bottom: 12px;

        >span {
          line-height: 24px;
          font-weight: 600 !important;
          font-size: 16px !important;
          color: #000;
        }

        >.van-icon-arrow {
          color: #00000057;
        }
      }

      .info-content {

        // display: flex;
        .content-desc {
          padding-bottom: 6px;
          font-weight: 400;
          font-size: 13px;
          color: #8e8e93;
        }

        .content-weight {
          font-weight: 700;
          font-size: 24px;
          color: #000;
        }

        .content-normal {
          margin-left: 6px;
          font-weight: 400;
          font-size: 12px;
          color: #8e8e93;
        }

        .content-normal.positive {
          color: #d70000;
        }

        .content-normal.negative {
          color: #48bb78;
        }

        // .content-normal.zero {
        //   color: #8e8e93;
        // }
        .content-left,
        .content-right {
          width: 50%;
          display: inline-block;
        }
      }
    }

    .empty-balance {
      display: flex;
      margin-bottom: 16px;
      border-radius: 8px;
      padding-top: 24px;
      padding-right: 16px;
      padding-bottom: 24px;
      padding-left: 16px;
      background: #ffffff;
      flex-wrap: wrap;
      justify-content: center;

      &>div:first-child {
        width: 100%;
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 12px;
        text-align: center;
      }

      &>div:nth-child(2) {
        width: 100%;
        font-weight: 400;
        font-size: 14px;
        color: #00000080;
        text-align: center;
      }
    }

    .row-no-bottom {
      .row-title {
        padding-bottom: 0;
      }
    }
  }
}

.wx-qrcode-popup {
  .wx-popup-title {
    font-weight: 600;
    font-size: 17px;
    line-height: 24px;
    text-align: center;
    color: #1d2129;
  }

  .wx-popup-desc {
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: #4e5969;
    margin-top: 8px;
    text-align: center;
  }

  .wx-popup-qrcode {
    margin: 12px auto 0;

    img {
      margin: 0 auto;
      display: block;
      width: 157px;
      height: 157px;
    }
  }
}
</style>
